import React from 'react';
import { IonButton, IonButtons, IonCard, IonContent, IonFooter, IonHeader, IonItem, IonLabel, IonList, IonListHeader, IonModal, IonSelect, IonSelectOption, IonToast, IonToolbar } from '@ionic/react';

//	L O C A L E

import { locale___App } from '../../App.locale';
import { locale___MdDishEditModal } from './md-dish-edit.locale';

//	S T Y L E

import './md-dish-edit.scss';

//	S T A T E   -   P R O P S

import { props___MdDishEditModal, state___MdDishEditModal, state___MdDishEditModal___default } from './md-dish-edit.state';

//	T Y P E S

import { type___api___response } from '../../types/types.api-response';
import { type___digitalmenu___dish_measurement_unit } from '../../types/types.digitalmenu';
import { type___modal___config } from '../../types/types.modals';

//	S E R V I C E S

import { service_RestApiService } from '../../services/service-api';
import { service_LocalizationService } from '../../services/service-localization';

//	C O M P O N E N T S

import ComSpinnerInlineComponent from '../../components/com-spinner-inline/com-spinner-inline';

//	C L A S S

export default class MdDishEditModal extends React.Component<props___MdDishEditModal, state___MdDishEditModal> {

//#region 																							C O N F I G

	private readonly MdDishEditModal___modal_config: type___modal___config = {
		breakpoints: [ 1 ],
		backdropDismiss: true,
		handle: true,
		initialBreakpoint: 1,
		keyboardClose: true,
		showBackdrop: true,
		onDidPresent: () => { this.event___onDidPresent(); },
		onDidDismiss: () => { this.event___onDidDismiss(); }
	};

//#endregion

//#region 																							D E C L A R A T I O N S
		
	private readonly _API: service_RestApiService = new service_RestApiService();
	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___MdDishEditModal,
	) {
		super(props);
		this.state = state___MdDishEditModal___default;
	}

//#endregion

//#region 																							R E A D   P R O P S

	private read_props___dish = async () => {
		const ___temp___dish: type___api___response = await this._API.dishes___read_single(this.state.dish___id);
		this.setState({
			dish___props: ___temp___dish.data,
			dish___props___isLoading: true,
		}, () => {
			if (this.state.dish___props !== null) {
				this.setState({
				
					dish___id: this.state.dish___props['dish_id'],
				
					field___dish___category: this.state.dish___props['dish_category']['dish_category_id'],
				
					field___dish___name: this.state.dish___props['dish_name'],
					field___dish___description: this.state.dish___props['dish_description'],
					field___dish___price: this.state.dish___props['dish_price'],
					field___dish___price_currency: this.state.dish___props['dish_price_currency'],
				
					field___dish___measurement_unit: this.state.dish___props['dish_measurement_unit'],
				
					field___dish___allergens: this.state.dish___props['dish_allergens'].map((___a: string) => { return ___a['dish_allergen_id']; }),
					field___dish___attributes: this.state.dish___props['dish_attributes'].map((___a: string) => { return ___a['dish_attribute_id']; }),

					dish___props___isLoading: false,

				});
			} else {
				this.setState({
					dish___id: null,
					dish___props___isLoading: true,
				}, () => {
					this.props.event___onDidDismiss();
				});
			}
		});
	}

	private read_props___dish_allergens = async () => {
		const ___temp___dish_allergens: type___api___response = await this._API.dishes_allergens___read_multi('alphabetical');
		this.setState({
			allergens_collections: ___temp___dish_allergens.data,
			allergens_collections___isLoading: false,
		})
	}

	private read_props___dish_attributes = async () => {
		const ___temp___dish_attributes: type___api___response = await this._API.dishes_attributes___read_multi();
		this.setState({
			attributes_collections: ___temp___dish_attributes.data,
			attributes_collections___isLoading: false,
		})
	}

	private read_props___dish_categories = async () => {
		const ___temp___dish_categories_collection: type___api___response = await this._API.dishes_categories___read_multi('alphabetical');
		this.setState({
			categories_collections: ___temp___dish_categories_collection.data,
			categories_collections___isLoading: false,
		})
	}

//#endregion

//#region 																							H A N D L E R S

	private handle___select___category = (___event: any) => {
		this.setState({
			field___dish___category: ___event.detail.value,
		});
	}

	private handle___select___measurement_unit = (___event: any) => {
		this.setState({
			field___dish___measurement_unit: ___event.detail.value as type___digitalmenu___dish_measurement_unit,
		});
	}

	private handle___select___allergen = (___allergen_id: string) => {
		let ___category_collection___temp: string[] = this.state.field___dish___allergens;
		switch (this.state.field___dish___allergens.includes(___allergen_id)) {
			case true: ___category_collection___temp = ___category_collection___temp.filter(___c => ___c !== ___allergen_id); break;
			case false: ___category_collection___temp.push(___allergen_id); break;
		}
		this.setState({
			field___dish___allergens: ___category_collection___temp,
		});
	}

	private handle___select___attribute = (___attribute_id: string) => {
		let ___category_attribute___temp: string[] = this.state.field___dish___attributes;
		switch (this.state.field___dish___attributes.includes(___attribute_id)) {
			case true: ___category_attribute___temp = ___category_attribute___temp.filter(___c => ___c !== ___attribute_id); break;
			case false: ___category_attribute___temp.push(___attribute_id); break;
		}
		this.setState({
			field___dish___attributes: ___category_attribute___temp,
		});
	}

	private handle___submit = () => {
		this.setState({
			dish___props___isSubmitting: true,
		}, async () => {
			const ___temp___dish_is_submitted: type___api___response = await this._API.dishes___submit(this.props.dish_digitalmenu, this.props.dish_id, this.state.field___dish___category, this.state.field___dish___name, this.state.field___dish___description, this.state.field___dish___price, this.state.field___dish___price_currency, this.state.field___dish___measurement_unit, this.state.field___dish___allergens, this.state.field___dish___attributes);
			this.setState({
				ionToast___dishSubmit___isSubmitted: (___temp___dish_is_submitted && ___temp___dish_is_submitted.response === 'success') ? true : false,
			}, () => {
				if (___temp___dish_is_submitted.response === 'success') {
					this.props.event___onDidDismiss();
				}
			});
		});
	}

//#endregion

//#region 																							L I F E C Y C L E

	private async event___onDidPresent() : Promise<void> {
		await this.read_props___dish_allergens();
		await this.read_props___dish_attributes();
		await this.read_props___dish_categories();
		this.setState({
			dish___id: this.props.dish_id ?? null,
			field___dish___category: this.props.dish_category ?? null,
		}, async () => {
			if (this.state.dish___id !== null) {
				await this.read_props___dish();
			} else {
				this.setState({
					dish___props___isLoading: false,
				});
			}
		});
	}

	private event___onDidDismiss() : void {
		this.setState({
			...state___MdDishEditModal___default
		});
	}

//#endregion

//#region 																							R E T U R N

	render() : React.ReactNode {
		return <>

			<IonToast isOpen={( this.state.ionToast___dishSubmit___isSubmitted === true )} message={ this._LOCALE.translate(locale___MdDishEditModal.ionToast___added) } duration={ 3000 } color="success" position="top" onDidDismiss={() => { this.setState({ ionToast___dishSubmit___isSubmitted: null }); }}/>
			<IonToast isOpen={( this.state.ionToast___dishSubmit___isSubmitted === false )} message={ this._LOCALE.translate(locale___MdDishEditModal.ionToast___error) } duration={ 3000 } color="danger" position="top" onDidDismiss={() => { this.setState({ ionToast___dishSubmit___isSubmitted: null }); }}/>

			<IonModal isOpen={ this.props.isOpen } {...this.MdDishEditModal___modal_config}>

				<IonHeader>
					<IonToolbar>
						<IonButtons slot="end">
							<IonButton onClick={ this.props.event___onDidDismiss }>
								<b>{ this._LOCALE.translate(locale___App.modal___topBar___button___close) }</b>
							</IonButton>
						</IonButtons>
					</IonToolbar>
				</IonHeader>

				<IonContent forceOverscroll={ false }>
					{(this.state.dish___props___isLoading === true || this.state.dish___props___isSubmitting === true) ? <>

						<br />
						<br />
						<br />
						<br />
						<ComSpinnerInlineComponent/>
					
					</> : <>

						{/**
						 * 
						 * 
						 * 
						 * 						I N F O R M A Z I O N I
						 * 
						 * 
						 * 
						 */}

						<IonListHeader>
							<IonLabel>
								<i className="fas fa-info-circle"></i>
								<span>{ this._LOCALE.translate(locale___MdDishEditModal.ionToast___title) }</span>
							</IonLabel>
						</IonListHeader>
					
						<section className="md-modal---container md-dish-edit---container">
							
							<IonCard>
								<IonList>
									<IonItem className="is-ion-item-button">
										{(this.state.categories_collections___isLoading === true) ? <>
											<ComSpinnerInlineComponent />
										</> : <>
											<IonSelect key="munit___" interface="popover" label="Seleziona categoria" placeholder="Nessuna" value={ this.state.field___dish___category } onIonChange={ this.handle___select___category }>
												<IonSelectOption disabled={ true } key="___dskad" value="">{ this._LOCALE.translate(locale___MdDishEditModal.field___select_category) }</IonSelectOption>
												{this.state.categories_collections.map((___dc: any, ___dc___idx: number) => {
													return <>
														<IonSelectOption key={ ___dc___idx['dish_category_id'] } value={ ___dc['dish_category_id'] }>{ ___dc['dish_category_name'] }</IonSelectOption>
													</>;
												})}
											</IonSelect>
										</>}
									</IonItem>
								</IonList>
							</IonCard>

							<br />

							<label htmlFor="field---poi-name">
								<p className="input---nb-label is-required">{ this._LOCALE.translate(locale___MdDishEditModal.field___product_name) }</p>
								<input type="text" id="field---poi-name" className="input---nb-outlined" placeholder={ this._LOCALE.translate(locale___MdDishEditModal.field___product_name___placeholder) } value={ this.state.field___dish___name } onInput={(___e: any) => { this.setState({ field___dish___name: ___e.target.value}); }}/>
							</label>

							<br />

							<label htmlFor="field---poi-description">
								<p className="input---nb-label">{ this._LOCALE.translate(locale___MdDishEditModal.field___product_description) }</p>
								<textarea id="field---poi-description" className="input---nb-outlined" placeholder={ this._LOCALE.translate(locale___MdDishEditModal.field___product_description___placeholder) } style={{height:'150pt'}} value={ this.state.field___dish___description } onInput={(___e: any) => { this.setState({ field___dish___description: ___e.target.value }); }}></textarea>
							</label>

							<br />

							{(this.state.attributes_collections___isLoading === true) ? <>
								<ComSpinnerInlineComponent />
							</> : <>
								<section className="md-dish-edit---allergens">
									{this.state.attributes_collections.map((___attribute: any, ___attribute___idx: number) => {
										const ___c_a___child___checkbox___id: string = 'md-entry-attributes---' + ___attribute['dish_attribute_id'];
										return <>
											<input key={ ___attribute___idx + 1900 } type="checkbox" id={ ___c_a___child___checkbox___id } value={ ___attribute['dish_attribute_id'] } checked={ this.state.field___dish___attributes.includes(___attribute['dish_attribute_id']) } onInput={() => { this.handle___select___attribute(___attribute['dish_attribute_id']); }}/>
											<label key={ ___attribute___idx + 1100 } htmlFor={ ___c_a___child___checkbox___id } style={{borderColor:'var(--color---folly)',backgroundColor:'var(--color---folly)'}}>
												<i className="fas fa-check"></i>
												<i className="far fa-circle"></i>
												<span>{ ___attribute['dish_attribute_name'] }</span>
											</label>
										</>;
									})}
								</section>
							</>}

							<br />

							<label htmlFor="field---poi-price">
								<p className="input---nb-label is-required">{ this._LOCALE.translate(locale___MdDishEditModal.field___product_price) }</p>
								<section style={{display:'flex',gap:'10pt'}}>
									<input type="number" id="field---poi-price" className="input---nb-outlined" placeholder="0.00" min={ 0 } value={ this.state.field___dish___price } onInput={(___e: any) => { this.setState({ field___dish___price: ___e.target.value }); }} style={{textAlign:'right'}}/>
									<p style={{fontWeight:'bold'}}>€</p>
								</section>
							</label>

							<br />

							<IonCard>
								<IonList>
									<IonItem>
										<IonSelect key="munit___" interface="popover" label={ this._LOCALE.translate(locale___MdDishEditModal.field___product_unit___select) } placeholder={ this._LOCALE.translate(locale___MdDishEditModal.field___product_unit___none) } value={ this.state.field___dish___measurement_unit } onIonChange={ this.handle___select___measurement_unit }>
											<IonSelectOption key="munit___null" value="">{ this._LOCALE.translate(locale___MdDishEditModal.field___product_unit___none) }</IonSelectOption>
											<IonSelectOption key="munit___pz" value="pz">{ this._LOCALE.translate(locale___MdDishEditModal.field___product_unit___piece) }</IonSelectOption>
											<IonSelectOption key="munit___kg" value="kg">{ this._LOCALE.translate(locale___MdDishEditModal.field___product_unit___kilo) }</IonSelectOption>
											<IonSelectOption key="munit___hg" value="hg">{ this._LOCALE.translate(locale___MdDishEditModal.field___product_unit___hg) }</IonSelectOption>
											<IonSelectOption key="munit___g" value="g">{ this._LOCALE.translate(locale___MdDishEditModal.field___product_unit___gram) }</IonSelectOption>
											<IonSelectOption key="munit___l" value="l">{ this._LOCALE.translate(locale___MdDishEditModal.field___product_unit___liter) }</IonSelectOption>
										</IonSelect>
									</IonItem>
								</IonList>
							</IonCard>

							<br />

							<p className="input---nb-label">{ this._LOCALE.translate(locale___MdDishEditModal.field___product_allergens) }</p>
							{(this.state.allergens_collections___isLoading === true) ? <>
								<ComSpinnerInlineComponent />
							</> : <>
								<section className="md-dish-edit---allergens">
									{this.state.allergens_collections.map((___allergen: any, ___allergen___idx: number) => {
										const ___c_e___child___checkbox___id: string = 'md-entry-interests----cb-cat-event-child---' + ___allergen['dish_allergen_id'];
										return <>
											<input key={ ___allergen___idx + 1900 } type="checkbox" id={ ___c_e___child___checkbox___id } value={ ___allergen['dish_allergen_id'] } checked={ this.state.field___dish___allergens.includes(___allergen['dish_allergen_id']) } onInput={() => { this.handle___select___allergen(___allergen['dish_allergen_id']); }}/>
											<label key={ ___allergen___idx + 1100 } htmlFor={ ___c_e___child___checkbox___id } style={{borderColor:'var(--color---folly)',backgroundColor:'var(--color---folly)'}}>
												<i className="fas fa-check"></i>
												<i className="far fa-circle"></i>
												<span>{ ___allergen['dish_allergen_name'] }</span>
											</label>
										</>;
									})}
								</section>
							</>}

							<br />
							<br />

						</section>
		
					</>}
				</IonContent>

				<IonFooter>
					<section className="container---footer-section">
						{(this.state.field___dish___category !== null && this.state.field___dish___category !== '' && this.state.field___dish___name.length > 0) ? <>
							<button className="is-element is-button is-color---folly is-full-width" onClick={() => { this.handle___submit() }}>
								<i className="fas fa-check"></i>
								<h4>{ this._LOCALE.translate(locale___MdDishEditModal.field___button___save) }</h4>
							</button>
						</> : <>
							<button className="is-element is-button is-color---shadow is-full-width">
								<i></i>
								<h4>{ this._LOCALE.translate(locale___MdDishEditModal.field___button___disabled) }</h4>
							</button>
						</>}
					</section>
				</IonFooter>
				
			</IonModal>
		</>;
	}

//#endregion

}